const $jq = jQuery.noConflict();
$jq(document).ready(function () {  
    $jq('.custom-review-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      speed: 300,
      infinite: true,
      autoplaySpeed: 3000,
      autoplay: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });

  $jq("#rew_new").click(function(e) {
        e.preventDefault();
        var target = $jq(this).attr("href");
        $jq('html, body').animate({
            scrollTop: $jq(target).offset().top
        }, 2000);
    });
  });
